module.exports = __webpack_public_path__ + "img/flip_vertically.196211b6.svg";